import { useCallback, useEffect } from "react";

// Helpers
import fetchAgeVerificationData from "@common/components/helpers/AgeVerification/fetchAgeVerificationData";
import prepareAgeVerificationData from "@common/components/helpers/AgeVerification/prepareAgeVerificationData";
import { yearDifference } from "@common/components/helpers/datetime";

// Actions
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";
import { parseAgeVerificationResponse } from "@common/components/helpers/compliance";

// Client
import AgeVerificationClient from "@common/api/AgeVerificationClient";
import useLogin from "@common/components/hooks/useLogin";
import useCompliance from "./useCompliance";

const useAgeVerificationForm = ({ formData, form }) => {
  const [{ siteGuid }] = useLogin();
  const { resetComplianceForms, submitComplianceForm } = useCompliance();

  const watchIdType = form.watch("idType");

  useEffect(() => {
    const idOther = watchIdType && watchIdType.detailsRequired;
    AgeVerificationAction.dispatch({ idOther });
  }, [watchIdType, formData.idTypes]);

  const watchDob = form.watch("dateOfBirth");

  useEffect(() => {
    if (!watchDob) return;

    const years = yearDifference(watchDob);
    if (years < 18) {
      form.setValue("under18", true, { shouldValidate: true });
    } else {
      form.setValue("under18", false, { shouldValidate: true });
    }
    // asking for form as dependency but this caused an infinite rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchDob]);

  const handleFormLoad = useCallback(() => {
    fetchAgeVerificationData();
  }, []);

  useEffect(() => {
    handleFormLoad();
  }, [handleFormLoad]);

  const resetForm = (redirect) => {
    resetComplianceForms(redirect);
    handleFormLoad();
  };

  const onSubmit = (data) => {
    AgeVerificationAction.dispatch(data);

    const payload = prepareAgeVerificationData(data, formData, siteGuid);

    submitComplianceForm({
      client: AgeVerificationClient,
      payload,
      resetForm,
      desktopCallback: (response) =>
        form.reset(parseAgeVerificationResponse(response)),
    });
  };

  const onError = (errors) => console.error("Submit errors ", errors);

  return { onSubmit, onError, resetForm };
};
export default useAgeVerificationForm;
